import ReapproParam from '@/components/Reappro/ReapproParam'
import ReapproNext from '@/components/Reappro/ReapproNext'
import ReapproDetail from '@/components/Reappro/ReapproDetail'
import ReapproRecept from '@/components/Reappro/ReapproRecept'
import ReapproList from '@/components/Reappro/ReapproList'

let ReapproRouter = [
{
    path: '/reappro/param',
    name: 'ReapproParam',
    component: ReapproParam
},
{
    path: '/reappro/recept/:id',
    name: 'ReapproRecept',
    component: ReapproRecept
},
{
    path: '/reappro',
    name: 'ReapproList',
    component: ReapproList
},
{
  path: '/reappro/next/:id',
  name: 'ReapproNext',
  component: ReapproNext,
},
{
  path: '/reappro/detail/:id',
  name: 'ReapproDetail',
  component: ReapproDetail,
}]

export default ReapproRouter



// WEBPACK FOOTER //
// ./src/components/Reappro/router.js